import { render, staticRenderFns } from "./ResourceConflict.vue?vue&type=template&id=02ede4bc"
import script from "./ResourceConflict.vue?vue&type=script&lang=js"
export * from "./ResourceConflict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports